var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroceryStore24PxRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "local_grocery_store_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/maps/local_grocery_store_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99629 4H3.99629L7.59629 11.59L6.24629 14.03C5.51629 15.37 6.47629 17 7.99629 17H18.9963C19.5463 17 19.9963 16.55 19.9963 16C19.9963 15.45 19.5463 15 18.9963 15H7.99629L9.09629 13H16.5463C17.2963 13 17.9563 12.59 18.2963 11.97L21.8763 5.48C22.2463 4.82 21.7663 4 21.0063 4H6.20629L5.53629 2.57C5.37629 2.22 5.01629 2 4.63629 2H2.99629C2.44629 2 1.99629 2.45 1.99629 3C1.99629 3.55 2.44629 4 2.99629 4ZM7.99629 18C6.89629 18 6.00629 18.9 6.00629 20C6.00629 21.1 6.89629 22 7.99629 22C9.09629 22 9.99629 21.1 9.99629 20C9.99629 18.9 9.09629 18 7.99629 18ZM16.0063 20C16.0063 18.9 16.8963 18 17.9963 18C19.0963 18 19.9963 18.9 19.9963 20C19.9963 21.1 19.0963 22 17.9963 22C16.8963 22 16.0063 21.1 16.0063 20Z",
    fill: "#241D3C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroceryStore24PxRounded);
export default __webpack_public_path__ + "static/media/grocery_store_24px_rounded.f1a49ce8.svg";
export { ForwardRef as ReactComponent };